import { z } from 'zod/v4';

export const reportReasonSchema = z.enum([
  'SPAM',
  'HARASSMENT',
  'HATE_SPEECH',
  'VIOLENCE',
  'SEXUAL_CONTENT',
  'MISINFORMATION',
  'COPYRIGHT',
  'OTHER',
]);

export const reportStatusSchema = z.enum(['PENDING', 'REVIEWING', 'RESOLVED', 'DISMISSED']);

export const createReportSchema = z.object({
  entityType: z.enum(['POST', 'COMMENT', 'REVIEW'], { message: 'Тип сущности обязателен' }),
  entityId: z.number({ message: 'ID сущности обязателен' })
    .int('ID сущности должен быть целым числом')
    .positive('ID сущности должен быть положительным'),
  reason: reportReasonSchema,
  description: z.string().max(1000, 'Описание слишком длинное (максимум 1000 символов)').optional(),
});

export const resolveReportSchema = z.object({
  status: z.enum(['RESOLVED', 'DISMISSED'], { message: 'Статус обязателен' }),
  resolutionReason: z.string().max(1000, 'Причина слишком длинная (максимум 1000 символов)').optional(),
});

export type CreateReportDto = z.infer<typeof createReportSchema>;
export type ResolveReportDto = z.infer<typeof resolveReportSchema>;
export type ReportStatus = z.infer<typeof reportStatusSchema>;
export type ReportReason = z.infer<typeof reportReasonSchema>;
